import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import './style.css'

class NRTModal extends Component {


    state = {
        open: false
    }


    componentWillMount() {
        this.setState({open: this.props.open})
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.open === false) {

            if (setTimeout) {
                setTimeout(() => {
                    this.setState({open: false})
                }, 400)

            } else {
                this.setState({open: false})
            }
        } else {
            this.setState({open: true})
        }
    }


    render() {


        const {onOverlayClick} = this.props
        const closingCls = this.props.open ? '' : 'closing'


        return this.state.open ? ReactDOM.createPortal(
            <div className={'nrt-modal ' + closingCls}>

                <div className="overlay"
                     onClick={onOverlayClick ? onOverlayClick : () => null}
                     style={{
                         cursor: onOverlayClick ? 'pointer' : 'default'
                     }}
                >
                    <div className="nrt-modal-window"
                         onClick={(evt) => {
                             evt.stopPropagation()
                         }}
                    style={{cursor:'default'}}>

                        <h2>{this.props.title}</h2>
                        <div className="message-container">
                            {this.props.message}
                        </div>

                        <div className="buttons-container">
                            {
                                this.props.buttons
                                    .map((btn, index) =>
                                        <div key={'btn-modal-' + index}>{btn}</div>)
                            }

                        </div>

                    </div>
                </div>

            </div>,
            document.body,
            ) :
            null
    }
}


NRTModal.propTypes = {
    title: PropTypes.string,
    open: PropTypes.bool,
    message: PropTypes.any,
    buttons: PropTypes.array,
    onOverlayClick: PropTypes.func,

}

NRTModal.defaultProps = {
    open: false,
    buttons: [],
}

export default NRTModal



// WEBPACK FOOTER //
// ./src/components/_common/Modal/index.js